import React from "react";

export default function FeatureItem(props) {
    const { title, image, active } = props;
    return (
        <li
            className={
                active
                    ? "mba-features-nav-item active"
                    : "mba-features-nav-item"
            }
            onClick={e => {
                props.onClick();
            }}
        >
            {/* <img className="about-mba-course__feature-item__icon" src={image} alt="" /> */}
            <h4 className="mba-features-nav-item__title">{title}</h4>
        </li>
    );
}
